/**
 * Create by lizj 2018/6/15
 */


;(function () {

    dialogResetCtrl.$inject = ['event', 'request'];
    angular
        .module('DSSXAPP')
        .component('dialogReset', {
            template:'<div class="dialog-reset-component" ng-show="vm.d.showDialogReset"><div class="dialog-reset-wrap"></div><div class="dialog-reset zoomIn"><div class="dialog-reset-title"><i class="iconfont icon-close" ng-click="vm.f.cancel()"></i><div>重置数据</div></div><div class="dialog-reset-content">重置数据后，零效果产品模块将恢复为初始状态，已经删除或者下架的产品会被还原。如果已提交相关作答，建议确认批改完成后再进行重置，以免影响考核成绩</div><div class="dialog-reset-footer"><button class="button-primary button-medium sure" ng-click="vm.f.sure()">我已知晓风险，确定重置</button> <button class="button-normal button-medium cancel" ng-click="vm.f.cancel()">取消</button></div></div></div>',
            bindings: {},
            controllerAs: 'vm',
            controller: dialogResetCtrl
        });

    function dialogResetCtrl(event, request) {
        this.$onInit = onInit;

        var vm = this;

        vm.d = {
            showDialogReset: false
        };

        vm.f = {
            sure: sure,
            cancel: cancel
        };

        function onInit() {
            initEvent();
        }

        function initEvent() {
            event.on('layout.showDialogReset', function (type) {
                vm.d.showDialogReset = type;
            })
        }

        function sure() {
            var config = {
                method: 'reset'
            };

            updateZeroEffectPrd(config);
            cancel();
        }

        function cancel() {
            vm.d.showDialogReset = false;
        }

        //跟新零效果产品
        function updateZeroEffectPrd(data) {
            request.post('/usr/api/updateZeroEffectPrd', {}, data, true)
                .then(updateSuc, updateErr)
            ;

            function updateSuc(res) {
                if (res.code === 0) {
                    layer.msg('重置成功', {icon: 1});
                }
                event.emit('reset-success');
            }

            function updateErr(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'dialogResetCtrl',
                    funcName: 'updateZeroEffectPrd',
                    text: 'dialogResetCtrl fail'
                });
            }
        }

    }

})();

